// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"86bb073b","79":"dcf9d1a5","109":"ad204922","185":"adcdfcba","285":"7c567a04","763":"b6370cd7","974":"28e079d2"}[chunkId] + ".js";
};